
'use strict';

var ArctickClient = require('../../apiClient');
var util = require('util');

function CPLs() {
    ArctickClient.apply(this, arguments);
}

util.inherits(CPLs, ArctickClient);

CPLs.prototype.getCPLs = function(options, callback) {
    this._makeRequest({
        method: 'GET',
        path: '/api/v2/plugins/'+ process.env.ACTUALIZAR_CATALOGO +'/custom-tables/Cpl/?pageSize=50000'
    }, callback);
}

module.exports = CPLs;
